import { NumericQuestionDTO } from 'jobs/dtos/questions'
import { action, computed, observable, makeObservable } from 'mobx'
import { numberToLocaleString, roundToPrecision } from 'utils/number-util'
import { isNotNil } from 'utils/object-util'
import { QuestionInputValue } from '../input-value-types'
import { QuestionValidationResult } from '../QuestionValidationResult'
import QuestionViewModelBase, {
  QuestionViewModelPort,
} from '../QuestionViewModelBase'

export default class NumericQuestionViewModel extends QuestionViewModelBase<NumericQuestionDTO> {
  @observable answer?: number | undefined = 0
  @observable decimalPlaces = 0

  constructor(private numericTimeQuestionView: QuestionViewModelPort) {
    super(numericTimeQuestionView)

    makeObservable(this)
  }

  @computed
  get isAnswered(): boolean {
    return this.answer !== undefined
  }

  protected textAnswer(): string {
    return typeof this.answer === 'number'
      ? numberToLocaleString(this.answer, this.decimalPlaces)
      : ''
  }

  hydrate(dto: NumericQuestionDTO) {
    this.decimalPlaces =
      dto.format && dto.format.type === 'Decimal' ? dto.format.places || 0 : 0
  }

  @action.bound
  change(newValue: number | null | undefined) {
    this.answer = isNotNil(newValue) ? newValue : undefined
    this.notify()
  }

  protected hydrateAnswer(answer: unknown): void {
    this.answer =
      typeof answer === 'number'
        ? roundToPrecision(answer, this.decimalPlaces)
        : typeof answer === 'string'
          ? roundToPrecision(parseFloat(answer), this.decimalPlaces)
          : undefined
  }

  protected serializeAnswer() {
    return this.answer
  }

  validate(): QuestionValidationResult {
    const value = this.answer
    const failed = QuestionValidationResult.failed(['Please enter a number.'])
    if (!isNotNil(value)) {
      return failed
    }

    if (Number.isNaN(value)) {
      return failed
    }

    return QuestionValidationResult.ok()
  }

  toInputValue(): QuestionInputValue {
    return { type: 'NUMERIC', value: this.answer }
  }
}
